export enum AccordionPanelPadding {
  none = 'none',
  horizontalOnly = 'horizontal-only',
  verticalOnly = 'vertical-only',
  all = ''
}
